import React from "react";
import { Loader2, Inbox } from "lucide-react";

export function Loading({ label = "Ładowanie..." }) {
  return (
    <div className="flex flex-col items-center justify-center py-20 text-muted-foreground" data-testid="loading-state">
      <Loader2 className="w-7 h-7 animate-spin text-primary mb-3" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function Empty({ label = "Brak danych", icon: Icon = Inbox }) {
  return (
    <div className="flex flex-col items-center justify-center py-16 text-muted-foreground" data-testid="empty-state">
      <Icon className="w-8 h-8 mb-3 opacity-50" />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function PageHeader({ title, subtitle, children }) {
  return (
    <div className="flex flex-wrap items-end justify-between gap-4 mb-6 fade-up">
      <div>
        <h1 className="font-head text-2xl sm:text-3xl font-bold tracking-tight text-white">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {children}
    </div>
  );
}

export function StatCard({ label, value, sub, accent = "gold", testId }) {
  const color = accent === "green" ? "up" : accent === "red" ? "down" : "gold-text";
  return (
    <div className="tmc-card p-4 sm:p-5 transition-all fade-up" data-testid={testId}>
      <div className="text-xs uppercase tracking-wider text-muted-foreground font-mono">{label}</div>
      <div className={`font-mono font-bold text-2xl mt-2 ${color}`}>{value}</div>
      {sub && <div className="text-xs text-muted-foreground mt-1">{sub}</div>}
    </div>
  );
}

export function fmt(n, digits = 2) {
  if (n === null || n === undefined || n === "") return "—";
  const num = Number(n);
  if (Number.isNaN(num)) return String(n);
  return num.toLocaleString(undefined, { minimumFractionDigits: digits, maximumFractionDigits: digits });
}
